import { FetcherList } from '@garpix/fetcher/fetcher-list/react-router'
import { dataStates } from '@garpix/fetcher'
import { api } from '@/api'
import { IFetcherListResults } from '@/interfaces/Fetcher'
import React from 'react'
import Section from '@/components/Section'
import Title from '@/components/Title'
import style from '../styles/tourn_detail.module.scss'
import ChampionshipMemberCard from '@/components/Cards/ChampionshipMemberCard'
import Filters from './Filters'
import Button from '@/components/Button'
import { useCurrentUser } from '@/hooks'
import NoSearchResults from '@/components/NoSearchResults'

const RegisteredLoad = ({ tournament }): React.ReactElement => {
  const { currentUser, isLoaded } = useCurrentUser()
  return (
    <FetcherList
      initFilter={{
        age: '10-14',
        page_size: 10,
        stage: tournament.property_tournament_stage_value ?? '1',
        id: tournament.id
      }}
      isScrollTop={false}
      isHistoryPush={false}
      api={api.getTournamentsMembers}
    >
      {({ results, isNext, showMore, status, loadData, filterParams }: IFetcherListResults<any[]>) => {
        // { results, status, loadData, filterParams, showMore, isNext }: IFetcherListResults<any[]>
        return (
          <Section>
            <Title type='h2' theme='h3' className={style.members__title}>
              Зарегистрированные участники
            </Title>

            <Filters handleFilter={loadData} initFilters={filterParams} tournament={tournament} />

            {results.length === 0 && status === dataStates.loaded
              ? (
                <NoSearchResults text='К сожалению, не удалось найти участников' />
                )
              : null}

            <ul className={style.members_list}>
              {results.map((el) => {
                const user = el.user
                return (
                  <li className={style.members__item} key={el.id}>
                    <ChampionshipMemberCard
                      name={user.name}
                      photo={user.personal_photo ?? ''}
                      isCurrentUser={isLoaded && currentUser.id === user.id}
                      city={user.personal_city ?? ''}
                      state={user.personal_state}
                      place={el.place}
                      score={el.score}
                    />
                  </li>
                )
              })}
            </ul>

            {isNext
              ? (
                <Button
                  disabled={status === dataStates.loading}
                  onClick={showMore}
                  size='large'
                  wide
                  outline
                >
                  Показать еще
                </Button>
                )
              : null}
          </Section>
        )
      }}
    </FetcherList>
  )
}

export {
  RegisteredLoad
}
